import { render, staticRenderFns } from "./CustomTextAreaComponent.vue?vue&type=template&id=0d45eddc&scoped=true&"
import script from "./CustomTextAreaComponent.vue?vue&type=script&lang=js&"
export * from "./CustomTextAreaComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomTextAreaComponent.vue?vue&type=style&index=0&id=0d45eddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45eddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
